/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm

// Core
import type ClientApplication from '@client/app';

/*----------------------------------
- TYPES
----------------------------------*/

declare global {
    interface Window {
        // Defined by loading gtag.js
        gtag: (
            name: string,
            action: string,
            params?: {
                event_category?: string,
                event_label?: string,
                value?: string,
            }
        ) => void,
    }
}

/*----------------------------------
- SERVICE
----------------------------------*/
export default class ClientMetrics {

    public constructor( public app: ClientApplication ) {

    }

    public start() {
        
    }

    // Tracking
    public event( 
        action: string,
        category?: string,
        label?: string,
        value?: string,
    ) {
        if (!window.gtag) return console.warn("[tracker] Google Analytics wasn't imported in header > scripts.");
        if (action === 'pageview')
            window.gtag('send', action);
        else
            window.gtag('event', action, {
                event_category: category, 
                event_label: label,
                value
            });
    }
}